import React from "react";
import Avatar from "components/Home/ui/Avatar";
import { useSelector } from "react-redux";
import { joinSpace } from "slices/spaceSlice";
import { toggleSpaceBox } from "slices/spaceMediaSlice";
import { loadAudioSounds } from "helpers/sounds";
import { selectEnterButtonLoading } from "slices/channels/spaceChannelSlice";
import Spinner from "components/General-UI/Spinner";

const MAX_PEOPLE_ICONS = 3;

const PresentButton = ({ id, peopleInSpace, inThisSpace, spaceBoxActive }) => {
  const enterButtonLoading = useSelector(selectEnterButtonLoading);

  let items = [];

  // For testing
  // console.log(peopleInSpace);
  // for (let i = 0; i < 3; i++) {
  //   items.push(
  //     <div className="branch-person" key={peopleInSpace[0].user_id}>
  //       <Avatar
  //         given_name={peopleInSpace[0].given_name}
  //         family_name={peopleInSpace[0].family_name}
  //         avatar_key={peopleInSpace[0].avatar_key}
  //       />
  //     </div>
  //   );
  // }

  for (let i = 0; i < MAX_PEOPLE_ICONS && peopleInSpace[i]; i++) {
    items.push(
      <div className="branch-person" key={peopleInSpace[i].user_id}>
        <Avatar
          given_name={peopleInSpace[i].given_name}
          family_name={peopleInSpace[i].family_name}
          avatar_key={peopleInSpace[i].avatar_key}
        />
      </div>
    );
  }
  return (
    <button
      className={`present-button`}
      onClick={(e) => {
        if (inThisSpace) {
          toggleSpaceBox();
        } else {
          loadAudioSounds();
          joinSpace(id);
        }
        e.stopPropagation();
      }}
    >
      {enterButtonLoading ? (
        <div className="space-loader">
          <Spinner immediateShow={true} small />
        </div>
      ) : (
        <>
          <div className="heads">{items}</div>
          <div className={`join ${inThisSpace ? "open" : ""} `}>
            {inThisSpace ? (spaceBoxActive ? "hide" : "show") : "join"}
          </div>
          <div className={`num-peeps ${inThisSpace ? "in-space" : ""}`}>
            {peopleInSpace.length}
          </div>
        </>
      )}
    </button>
  );
};

export default PresentButton;
